import ShowcaseCollectionView from './ShowcaseCollectionView';

export default ShowcaseCollectionView;
